import { useQuery } from '@tanstack/react-query';

// helper
import { BaseError } from '../../helpers/BaseError';

// models
import {
    AudienceMainModel,
    ALL_USERS_AUDIENCE_ID,
} from '../../models/audience.model';

// services
import API from '../../services/api';

// query keys
import audienceKeys from './_queryKeys';

const getAudience = async (id?: string): Promise<AudienceMainModel> => {
    const { data } = await API.getAudience(id);
    return data;
};

export default function useAudienceQuery(id?: string) {
    return useQuery<AudienceMainModel, BaseError>({
        queryKey: audienceKeys.getAudience(id),

        queryFn: () => {
            if (id !== ALL_USERS_AUDIENCE_ID) {
                return getAudience(id);
            } else {
                return Promise.resolve({
                    id: ALL_USERS_AUDIENCE_ID,
                    name: 'All Users',
                    filters: [],
                    formulas: [],
                    formula_count: 0,
                    created_at: '',
                });
            }
        },
        enabled: !!id,
        staleTime: 60 * 60,
    });
}
